import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import { secondary } from "../signals/Theme colors.signal";
import { PropCouponTypeData } from "../signals/couponsData.signal";
import { ProfileData, fetchProfileApi } from "../signals/profileData.signal";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
const Profile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ProfileData.value = "";
    const fetchProfile = async () => {
      try {
        const result = await fetchProfileApi();
        ProfileData.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchProfile();
  }, []);

  return (
    <>
      <div
        id="loginPage"
        className="flex-column gap-3 align-items-sm-center d-flex justify-content-center w-100"
      >
        <div className="loginContaner   p-md-5 w-100  rounded-3 d-flex justify-content-center align-items-center flex-column">
          <SideBar
            more={true}
            back={true}
            backFunction={() => {
              PropCouponTypeData.value = "";
              navigate(-1);
            }}
          />
          <div className="w-100 p-3">
            <div
              className="mb-1 p-3 border w-100 shadow"
              style={{
                borderRadius: "50% 20% / 10% 40%",
                background: secondary.value,
              }}
            >
              <div className="w-100 d-flex justify-content-center align-items-center flex-column text-center">
                <AccountCircleIcon style={{ fontSize: "100px" }} />
                <div className="mb-1 w-100 ms-3 me-3">
                  <p className="m-0 " style={{ fontSize: "18px" }}>
                    {ProfileData.value ? ProfileData.value[0].CLIANAME : ""}
                  </p>
                  <p className="m-0 " style={{ fontSize: "18px" }}>
                    {ProfileData.value ? ProfileData.value[0].CLICODE : ""}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="mb-3">
              <h6 className="m-0">
                {translateText(currentLanguage.value, "MobileNumber")}:
              </h6>
              <div className=" d-flex justify-content-between align-items-center ">
                <p className="m-0 ">
                  {ProfileData.value ? ProfileData.value[0].MOBLILE_NO1 : ""}
                </p>
              </div>
            </div>
            <hr />
            <div className="mb-3">
              <h6 className="m-0">
                {translateText(currentLanguage.value, "email")}:
              </h6>
              <div className=" d-flex justify-content-between align-items-center ">
                <p className="m-0 ">
                  {ProfileData.value ? ProfileData.value[0].EMAIL : ""}
                </p>
              </div>
            </div>
            <hr />
            <div className="mb-3">
              <h6 className="m-0">
                {translateText(currentLanguage.value, "representative")}:
              </h6>
              <div className=" d-flex justify-content-between align-items-center ">
                <p className="m-0 ">
                  {currentLanguage.value === "ar"
                    ? ProfileData.value
                      ? ProfileData.value[0].REPANAME
                      : ""
                    : ProfileData.value
                    ? ProfileData.value[0].REPNAME
                    : ""}
                </p>
              </div>
            </div>
            <hr />
            <div className="mb-3">
              <h6 className="m-0">
                {translateText(currentLanguage.value, "representativeNo")}:
              </h6>
              <div className=" d-flex justify-content-between align-items-center ">
                <p className="m-0 ">
                  {ProfileData.value ? ProfileData.value[0].REPTEL1 : ""}
                </p>
              </div>
            </div>
            <hr />
            <div className="w-100 d-flex justify-content-center align-items-center flex-column text-center">
              <SupportAgentIcon />
              <div className="mb-3 text-center">
                <h6 className="m-0">
                  {translateText(currentLanguage.value, "CustomerService")}:
                </h6>
                <p className="m-0 ">{920000531}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile;
